import { LoaderFunction } from "react-router-dom";
import { clearLicenseCache } from "../../../../common/api/decimal/methods/cache";
import usePromiseFetcher from "../../../../common/core-ui/usePromiseFetcher";
import { DecimalResult } from "../../../../common/api/decimal/utils";

// The response data is not needed here, just the ok status.
export type UpdateResult = DecimalResult<unknown>;

export const updateLibraryAction: LoaderFunction =
  (): Promise<UpdateResult> => {
    const response = clearLicenseCache();
    return response;
  };

export function useUpdateLibraryFetcher() {
  return usePromiseFetcher<UpdateResult>({
    waitForIdle: true,
  });
}
